import { Component, computed, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { Attachment, Attachments } from 'src/app/models/types/Product/Product.type';
import { forkJoin } from 'rxjs';
import { ProductsService } from 'src/app/services/api/products.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SharedModule } from 'src/app/modules/shared.module';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-attachments-modal',
  imports: [
    ModalComponent,
    SharedModule
  ],
  templateUrl: './attachments-modal.component.html',
  styleUrl: './attachments-modal.component.scss'
})
export class AttachmentsModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  private _attachmentList: WritableSignal<Attachments> = signal([]);
  protected attachmentList: Signal<Attachments> = computed(() => this._attachmentList());

  constructor(
    public readonly sharedService: SharedService,
    public readonly loaderService: LoaderService,
    public readonly productsService: ProductsService,
  ) { }

  openModal(mediaUrls: string[]) {
    this.loaderService.show();
    let docs = [...mediaUrls]
      .filter(media => !(media.endsWith('.jpg') || media.endsWith('.png') || media.endsWith('.jpeg')))
      .map((doc) => ({ name: '', url: doc } as Attachment));
    if (docs.length > 0) {
      forkJoin(docs.map(doc => this.productsService.getDocumentFilename(doc.url)))
        .subscribe({
          next: (responses) => {
            responses.forEach((res, i) => {
              docs[i].name = decodeURI(res);
            })
            this._attachmentList.set(docs);
            this.loaderService.hide();
          },
          error: (err) => {
            this._attachmentList.set([]);
            console.log('error', err);
            this.loaderService.hide();
          }
        });
    }
    this.modal.buildModal(() => this.handleClose());
  }

  getDocumentFileName(url: string, docs?: Attachments) {
    // this.loaderService.show();
    this.productsService.getDocumentFilename(url).subscribe({
      next: (res) => {
        this._attachmentList.update(list => ([...list, { name: res, url }]));
        // this.loaderService.hide();
      },
      error: (err) => {
        console.log('error', err);
        // this.loaderService.hide();
      }
    });
    setTimeout(() => {
      if (docs) {
        docs.shift();
        if (docs.length > 0) {
          this.getDocumentFileName(docs[0].url, docs);
        }
      }
    }, 500);
  }

  handleConfirm() {
    this.handleClose()
  }

  private handleClose() {
    this.modal.dismiss();
  }
}
